import React from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AuraBadgeProps {
  value: number | null | undefined;
  previous?: number | null;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: { icon: 'w-3.5 h-3.5', text: 'text-xs', pad: 'px-2 py-1' },
  md: { icon: 'w-4 h-4', text: 'text-sm', pad: 'px-3 py-1.5' },
  lg: { icon: 'w-5 h-5', text: 'text-base', pad: 'px-3.5 py-2' },
};

export default function AuraBadge({ value, previous = null, className, size = 'md' }: AuraBadgeProps) {
  if (value === null || value === undefined) return null;
  const s = sizeMap[size];
  const increased = previous !== null && value > (previous ?? 0);
  const decreased = previous !== null && value < (previous ?? 0);

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full bg-white/10',
        s.pad,
        increased ? 'text-green-400' : decreased ? 'text-red-400' : 'text-white',
        className
      )}
      aria-label={`Aura ${value}`}
    >
      <Sparkles className={cn(s.icon, increased ? 'text-green-400' : decreased ? 'text-red-400' : 'text-purple-500')} />
      <span className={cn('font-medium', s.text)}>{Number(value).toLocaleString()}</span>
    </div>
  );
}
